import { ChangeEvent, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setEditorSize, toggleEventPreviewMode } from '../../../store/actions/admin/create-event';
import { useTypedSelector } from '../../../store/reducers/use-typed-selector';
import { EPreviewTypes } from '../../../types/working-model';
import { showAlert } from '../../general-ui/alert/alert-service';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import IconToggle from '../../general-ui/icon-toggle/icon-toggle';
import { CopyEventUrlButton } from '../events/event-details-header';
import PublishEvent from './publish-event';

type iconToggle = 'desktop' | 'tablet' | 'mobile';
export default function CreateUI(): JSX.Element {
	const {
		CreateEventReducer: {
			editorSize,
			workingEvent,
			saving
		},
		CreateSessionReducer: {
			workingSession
		}
	} = useTypedSelector(state => state);
	const dispatch = useDispatch();
	const [publishModalOpen, setPublishModalOpen] = useState(false);

	const handlePreview = () => {
		const onAgendaPage = window.location.href.indexOf("/event-agenda") > -1 || window.location.href.indexOf("/on-demand") > -1;
		const onRegistrationPage = (window.location.href.indexOf("/registration") > -1);
		const onLandingPage = window.location.href.indexOf("/landing") > -1;
		const onSession = window.location.href.indexOf("/session/") > -1;
		const onHomepage = window.location.href.indexOf("/home") > -1;
		const noHomeEvent = window.location.href.indexOf("/event") > -1;

		// display registration preview modal
		if (onLandingPage && workingEvent) {
			return dispatch(toggleEventPreviewMode(EPreviewTypes.Landing));
		} else if (onSession && workingSession) {
			return dispatch(toggleEventPreviewMode(EPreviewTypes.Session));
		} else if (onRegistrationPage && workingEvent) {
			if (!workingEvent.registration_on) {
				// if registration not turned on for event and tring to view reg preview, show alert
				return showAlert({
					message: 'Preview Unavailable',
					description:
						'Turn on registration for the event to view the Registration preview.',
					type: 'error',
					duration: 3000,
				});
			}
			return dispatch(toggleEventPreviewMode(EPreviewTypes.Registration));
		} else if (onAgendaPage && workingEvent) {
			// admin is on post register sessions page
			return dispatch(toggleEventPreviewMode(EPreviewTypes.Agenda));
		} else if (onHomepage && workingEvent) {
			// admin is on homepage editor preview page
			return dispatch(toggleEventPreviewMode(EPreviewTypes.Home));
		} else if (noHomeEvent && workingEvent) {
			if (workingEvent.sessions.length > 1) {
				return dispatch(toggleEventPreviewMode(EPreviewTypes.Home));
			} else {
				return dispatch(toggleEventPreviewMode(EPreviewTypes.Session));
			}
		}
		// reset preview mode to make sure we don't accidentally show wrong preview
		showAlert({
			message: 'Preview Unavailable',
			description:
				'Preview currently unavailable.',
			type: 'error',
			duration: 3000,
		});
		dispatch(toggleEventPreviewMode(null));
		return;
	};

	const handlePublish = useCallback(() => {
		setPublishModalOpen(true);
	}, []);

	const cancelPublish = useCallback(() => {
		setPublishModalOpen(false);
	}, []);

	const handleViewToggle = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
		// setSelectedIcon(target.value as iconToggle);
		dispatch(setEditorSize(value as iconToggle));
	};

	return (
		<div className="create-ui">
			<IconToggle
				leftIconName={ICONS.DESKTOP_SLIM}
				leftValue="desktop"
				middleIconName={ICONS.TABLET_SLIM}
				middleValue="tablet"
				rightIconName={ICONS.PHONE_SLIM}
				rightValue="mobile"
				selected={editorSize}
				onToggle={handleViewToggle}
			/>

			<button disabled={saving} className="small" onClick={handlePreview}>
				<Icon name={ICONS.VIEWERS_EYE} color={COLORS.WHITE} size={12} />
				Preview
			</button>
			<CopyEventUrlButton event={workingEvent} />
			{/* "a" element is a temporary solution */}
			<button className="small primary" onClick={handlePublish}>
				Publish Event
			</button>

			<PublishEvent open={publishModalOpen} close={cancelPublish} />
		</div>
	);
}
